export default __webpack_public_path__ + "599a0d9907f7d54907ce444af8b28f82.svg";